<!--Signup Pregnant Modal Starts-->
<div class="modal fade auth-modal" id="signup-modal-pregnant" data-keyboard="false" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content w-100">
      <div class="modal-body">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-5 image-section">
              <img src="../../../../../assets/Images/Signup-pregnant.svg" class="content-image" alt="Login">
            </div>
            <div class="col-md-7 px-4 pb-3">
              <div class="d-flex flex-column">
                <span class="title mt-3">Signup</span>
                <div *ngIf="errorMessage && errorMessage.length!=0"
                  class="alert alert-danger mt-3 alert-dismissible fade show error-message" role="alert">
                  {{errorMessage}}
                  <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <form class="d-flex flex-column" #regMumForm="ngForm">
                  <span class="input-label mt-3 mb-1">Name</span>
                  <input class="form-control form-control-sm header-search" placeholder="Name"
                    [(ngModel)]="registerMumForm.name" #name="ngModel" name="name" required>
                  <span *ngIf="name.invalid && name.touched" class="error-text">This field is required</span>

                  <span class="input-label mt-3 mb-1">Surname</span>
                  <input class="form-control form-control-sm header-search" placeholder="Name"
                         [(ngModel)]="registerMumForm.surname" #surname="ngModel" name ="surname" required>
                  <span *ngIf="surname.invalid &&surname.touched" class="error-text">This field is required</span>

                  <span class="input-label mt-3 mb-1">Email</span>
                  <input class="form-control form-control-sm header-search" type="email" placeholder="Email"
                    name="email" [(ngModel)]="registerMumForm.userEmail" #email="ngModel" [email]="true" required>
                  <span *ngIf="email.invalid && email.touched" class="error-text">This field is required</span>

                  <div class="row">
                    <div class="col-md-6 pr-md-0">
                      <div class="d-flex flex-column">
                        <span class="input-label mt-3 mb-1">Country code</span>
                        <mat-form-field class="w-100">
                          <mat-select [(ngModel)]="registerMumForm.countryCode" name="country code mum"
                            id="country-code-mum" required>
                            <mat-option *ngFor="let country of countries" [value]="country.dial_code">
                              <img class="dropdown-profile-img" [src]="country.flag">{{country.name}}
                              <span class="text-muted">({{country.dial_code}})</span>
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="d-flex flex-column">
                        <span class="input-label mt-3 mb-1">Phone</span>
                        <input class="form-control form-control-sm header-search" type="text" placeholder="Phone"
                          [(ngModel)]="registerMumForm.userPhonenumber" #phone="ngModel" name="phone" minlength="7"
                          maxlength="13" required (keypress)="keyPressNumbersDecimal($event)">
                        <span *ngIf="phone.invalid && phone.touched" class="error-text">Please enter a valid phone
                          number</span>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="d-flex flex-column">
                        <span class="input-label mt-3 mb-1">Area</span>
                        <mat-form-field class="w-100">
                          <mat-select [(ngModel)]="registerMumForm.area" #area="ngModel" name="area" id="area">
                            <mat-option [value]="area.name" *ngFor="let area of areas">{{area.name}}</mat-option>
                          </mat-select>
                        </mat-form-field>
                        <span *ngIf="area.invalid && area.touched" class="error-text">Please choose a option</span>
                      </div>
                    </div>
                  </div>
                  <span class="input-label mt-3 mb-1">Address</span>
                    <input class="form-control form-control-sm header-search" type="text" placeholder="Address"
                           [(ngModel)]="registerMumForm.address" #address="ngModel" name ="address" required>
                  <span *ngIf="address.invalid &&address.touched" class="error-text">This field is required</span>

                  <div class="row">
                    <div class="col-md-5 pr-md-0">
                      <div class="d-flex flex-column">
                        <span class="input-label mt-3 mb-1">Age</span>
                        <input class="form-control form-control-sm header-search" type="number" placeholder="Age"
                          [(ngModel)]="registerMumForm.age" #age="ngModel" name="age" required>
                        <span *ngIf="age.invalid && age.touched" class="error-text">This field is required</span>
                      </div>
                    </div>
                    <div class="col-md-7">
                      <div class="d-flex flex-column">
                        <span class="input-label mt-3 mb-1">Due date</span>
                        <div class="input-icons">
                          <i class="fas fa-calendar info-icon" (click)="onDatePickerClick()"></i>
                          <input class="form-control form-control-sm header-search" matInput [matDatepicker]="picker"
                            [min]="minDate" placeholder="Due date" [(ngModel)]="registerMumForm.dueDate"
                            #dueDate="ngModel" name="dueDate" required>
                          <mat-datepicker-toggle id="due-date-picker" [style]="{'display':'None'}" matSuffix
                            [for]="picker">
                          </mat-datepicker-toggle>
                          <mat-datepicker #picker></mat-datepicker>
                          <span *ngIf="dueDate.invalid && dueDate.touched" class="error-text">This field is
                            required</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <span class="input-label mt-3 mb-1">Password</span>
                  <div class="input-icons">
                    <i class="fas eye-icon" [ngClass]="{'fa-eye': eye1, 'fa-eye-slash': !eye1}"
                      (click)="toggle('pregnant')"></i>
                    <input #PassPregnant class="form-control form-control-sm header-search" placeholder="Password"
                      type="password" [(ngModel)]="registerMumForm.userHashPassword" minlength="6" #password="ngModel"
                      name="password" required>
                    <span *ngIf="password.invalid && password.touched" class="error-text">Please enter a valid
                      password</span>
                  </div>
                </form>
                <button [disabled] = "regMumForm.invalid || submitMom || !registerMumForm.address.length"
                  class="btn btn-lg btn-theme mt-4" data-toggle="modal" data-target="#password-verify-modal"
                  (click)="register(userType.MUM)">Proceed To
                  Verification</button>
                <div class="d-flex flex-row justify-content-center mt-3">
                  <span class="footer mr-2">Already have an account?</span>
                  <span class="forgot-password" (click)="navigateToLogin()">Login</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--Signup Pregnant Modal Ends-->

<!--Signup Midwife Modal 1 Starts-->
<div class="modal fade auth-modal" id="signup-modal-midwife-1" data-keyboard="false" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content w-100">
      <div class="modal-body">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-5 image-section">
              <img src="../../../../../assets/Images/Signup-midwife.svg" class="content-image" alt="Login">
            </div>
            <div class="col-md-7 px-4 pb-3">
              <div class="d-flex flex-column">
                <form #regMidwifeForm="ngForm" class="d-flex flex-column">
                  <span class="title mt-3">Signup</span>
                  <span class="input-label mt-3 mb-1">Name</span>
                  <input class="form-control form-control-sm header-search" placeholder="Name"
                    [(ngModel)]="registerMidWifeForm.name" #mname="ngModel" name="mname" required>
                  <span *ngIf="mname.invalid && mname.touched" class="error-text">This field is required</span>

                  <span class="input-label mt-3 mb-1">Surname</span>
                  <input class="form-control form-control-sm header-search" placeholder="Surname"
                         [(ngModel)]="registerMidWifeForm.surname" #surname="ngModel" name="surname" required>
                  <span *ngIf="surname.invalid &&surname.touched" class="error-text">This field is required</span>

                  <span class="input-label mt-3 mb-1">Email</span>
                  <input class="form-control form-control-sm header-search" type="email" placeholder="Email"
                    [(ngModel)]="registerMidWifeForm.userEmail" #memail="ngModel" name="memail" [email]="true" required>
                  <span *ngIf="memail.invalid && memail.touched" class="error-text">This field is required</span>
                  <div class="row">
                    <div class="col-6 pr-md-0">
                      <div class="d-flex flex-column">
                        <span class="input-label mt-3 mb-1">Country code (Home)</span>
                        <mat-form-field class="w-100">
                          <mat-select [(ngModel)]="registerMidWifeForm.countryCode" name="country code midwife 1"
                            id="country-code-midwife-1" required>
                            <mat-option *ngFor="let country of countries" [value]="country.dial_code">
                              <img class="dropdown-profile-img" [src]="country.flag">{{country.name}}
                              <span class="text-muted">({{country.dial_code}})</span>
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="d-flex flex-column">
                        <span class="input-label mt-3 mb-1">Phone 1 (Home)</span>
                        <input class="form-control form-control-sm header-search" type="text" placeholder="Phone"
                          [(ngModel)]="registerMidWifeForm.userPhonenumber" #mphone="ngModel" name="mphone"
                          minlength="8" maxlength="13" required (keypress)="keyPressNumbersDecimal($event)">
                        <span *ngIf="mphone.invalid && mphone.touched" class="error-text">Please enter a valid phone
                          number</span>
                      </div>
                    </div>
                  </div>
                  <span class="input-label mt-3 mb-1">Phone 1 (Office)</span>
                  <input class="form-control form-control-sm header-search" type="text" placeholder="Phone"
                    [(ngModel)]="registerMidWifeForm.alternatePhonenumber" #mphone1="ngModel" name="mphone1"
                    minlength="10" maxlength="18" (keypress)="keyPressAlphaNumeric($event)">
                  <span class="input-label mt-3 mb-1">Address</span>
                  <input class="form-control form-control-sm header-search" type="text" placeholder="Address"
                         [(ngModel)]="registerMidWifeForm.address" #address="ngModel" name ="address" required>
                  <span *ngIf="address.invalid &&address.touched" class="error-text">This field is required</span>

                  <span class="input-label mt-3 mb-1">Ethnicity</span>
                  <mat-form-field class="w-100">
                    <mat-select name="ethnicity" id="Ethnicity" [(ngModel)]="registerMidWifeForm.ethnicity"
                      #ethnicity="ngModel" name="ethnicity" required>
                      <mat-option *ngFor="let ethnicity of ethnicities" [value]="ethnicity">{{ethnicity}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <span *ngIf="ethnicity.invalid && ethnicity.touched" class="error-text">Please choose a
                    option</span>
                  <span class="input-label mt-3 mb-2">Languages</span>
                  <mat-form-field class="w-100">
                    <mat-select #selectLanguage [(value)]="selectedLanguages" multiple id="Language"
                      [(ngModel)]="selectedLanguages" #language="ngModel" name="language">
                      <div>
                        <mat-option [value]="0" (click)="toggleAllSelection('Language')">All</mat-option>
                        <mat-option *ngFor="let language of languages" [value]="language">{{language}}
                        </mat-option>
                      </div>
                      <footer class="mr-2 mb-2 float-right">
                        <button mat-flat-button color="primary" class="done-btn" (click)="closeDropdown()">Done</button>
                      </footer>
                    </mat-select>
                  </mat-form-field>
                </form>
                <button [disabled]="regMidwifeForm.invalid || !registerMidWifeForm.address.length"
                  class="btn btn-lg btn-theme mt-4" data-toggle="modal" data-target="#password-verify-modal"
                  (click)="nextSignupMidwife()">Next</button>
                <div class="d-flex flex-row justify-content-center mt-3">
                  <span class="footer mr-2">Already have an account?</span>
                  <span class="forgot-password" (click)="navigateToLogin()">Login</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--Signup Midwife Modal 1 Ends-->

<!--Signup Midwife Modal 2 Starts-->
<div class="modal fade auth-modal" id="signup-modal-midwife-2" data-keyboard="false" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content w-100">
      <div class="modal-body">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-5 image-section">
              <img src="../../../../../assets/Images/Signup-midwife.svg" class="content-image" alt="Login">
            </div>
            <div class="col-md-7 px-4 pb-3">
              <div class="d-flex flex-column">
                <span class="title mt-3">Signup</span>
                <div class="d-flex flex-row">
                  <div class="navigation-arrow my-3" (click)="previousSignupMidwife()">
                    <i class="fas fa-long-arrow-alt-left arrow-icon"></i>
                  </div>
                  <span class="nav-header ml-3">Other details</span>
                </div>
                <form #regMidwifeForm2="ngForm" class="d-flex flex-column">
                  <div class="registered-midwife">
                    <span class="select-header">Are you a registered midwife?</span>
                    <div class="d-flex flex-row mt-1 mt-sm-0">
                      <div class="custom-control custom-radio mr-2">
                        <input type="radio" id="yes" name="registered" value="yes" class="custom-control-input"
                          [checked]="registeredMidwife" (change)="setRegisteredMidwife($event)">
                        <label for="yes" class="custom-control-label">Yes</label>
                      </div>
                      <div class="custom-control custom-radio">
                        <input type="radio" id="no" name="registered" value="no" class="custom-control-input"
                          [checked]="!registeredMidwife" (change)="setRegisteredMidwife($event)">
                        <label for="no" class="custom-control-label">No</label>
                      </div>
                    </div>
                  </div>
                  <span class="input-label mt-3 mb-1">Apc number</span>
                  <input [disabled]="!registeredMidwife" class="form-control form-control-sm header-search"
                    placeholder="Practice ID" [(ngModel)]="registerMidWifeForm.practiceId" #pId="ngModel" name="pId">
                  <span class="input-label mt-3 mb-1">Specialized in</span>
                  <mat-select #selectSpecialized [(value)]="serviceAreas.speciality" multiple id="Specialized in"
                    class="form-control form-control-sm header-search" placeholder="Select Option"
                    [(ngModel)]="serviceAreas.speciality" #speciality="ngModel" name="specializedin" required>
                    <div>
                      <mat-option [value]="0" (click)="toggleAllSelection('Specialized')">All</mat-option>
                      <mat-option *ngFor="let speciality of specialities" [value]="speciality">{{speciality}}
                      </mat-option>
                    </div>
                    <footer class="mr-2 mb-2 float-right">
                      <button mat-flat-button color="primary" class="done-btn" (click)="closeDropdown()">Done</button>
                    </footer>
                  </mat-select>
                  <span *ngIf="speciality.invalid && speciality.touched" class="error-text">Please
                    choose
                    a option</span>

                  <span class="input-label mt-3 mb-2">Service areas</span>
                  <mat-form-field class="w-100 mb-2">
                    <mat-select #area="ngModel" [(ngModel)]="selectedArea" name="area">
                      <mat-option *ngFor="let area of areas" [value]="area">{{area.name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field class="w-100">
                    <mat-select #selectAreas id="subarea" [(ngModel)]="services" multiple #subarea="ngModel"
                      name="subarea" [disabled]="selectedArea==undefined">
                      <div>
                        <mat-option [value]="0" (click)="toggleAllSelection('Area')">All</mat-option>
                        <mat-option *ngFor="let subArea of subAreas" [value]="subArea.name"
                          [ngClass]="{'d-none': selectedArea && subArea.parentId != selectedArea.id}">{{subArea.name}}
                        </mat-option>
                      </div>
                      <footer class="mr-2 mb-2 float-right">
                        <button mat-flat-button color="primary" class="done-btn" (click)="closeDropdown()">Done</button>
                      </footer>
                    </mat-select>
                  </mat-form-field>
                  <span class="input-label mt-3 mb-1">Experience</span>
                  <mat-form-field class="w-100">
                    <mat-select name="experience" id="Experience" [(ngModel)]="registerMidWifeForm.experienceInYears"
                      #expMd="ngModel" name="expMd" required>
                      <mat-option [value]="experience" *ngFor="let experience of experiences">{{experience}} years
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <span *ngIf="registerMidWifeForm.experienceInYears==0 && expMd.touched" class="error-text">Please
                    choose
                    a option</span>

                  <span class="input-label mt-3 mb-1">Password</span>
                  <div class="input-icons">
                    <i class="fas eye-icon" [ngClass]="{'fa-eye': eye2, 'fa-eye-slash': !eye2}"
                      (click)="toggle('midwife')"></i>
                    <input #PassMidwife class="form-control form-control-sm header-search" placeholder="Password"
                      type="password" [(ngModel)]="registerMidWifeForm.userHashPassword" minlength="6"
                      #mdpassword="ngModel" name="mdpassword" required>
                    <span *ngIf="mdpassword.invalid && mdpassword.touched" class="error-text">Please enter a valid
                      password</span>
                  </div>
                </form>
                <button [disabled]="regMidwifeForm2.invalid || submitMidwife" class="btn btn-lg btn-theme mt-4"
                  data-toggle="modal" data-target="#password-verify-modal" (click)="register(userType.MIDWIFE)">Proceed
                  To
                  Verification</button>
                <div class="d-flex flex-row justify-content-center mt-3">
                  <span class="footer mr-2">Already have an account?</span>
                  <span class="forgot-password" (click)="navigateToLogin()">Login</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--Signup Midwife Modal 2 Starts-->
